'use client';

import * as DS from '@aurorasolar/ds';
import Link from 'next/link';

import { privacyPolicyUrl } from '@/app/components';

import { D3 } from './D3';
import { H3 } from './H3';
import { NumberedStep } from './NumberedStep';
import { Section } from './Section';

type Props = { colorMode: 'dark' | 'light' };

export const EstimateSteps = ({ colorMode }: Props) => (
  <Section colorMode={colorMode} columns={1}>
    <DS.Flex flexDirection="column" gap={{ _: 7, lg: 10 }}>
      <D3 textAlign="center">Estimates in three easy steps</D3>
      <DS.Grid columnGap={4} flex={1} rowGap={{ _: 8, md: 0 }}>
        <DS.GridItem alignItems="center" gap={4} justifyContent="center" size={{ _: 'full', md: 'third' }}>
          <DS.Flex flex={1}>
            <NumberedStep>1</NumberedStep>
            <H3>Enter your address</H3>
            <DS.Text as="p" text="body14">
              <span>
                Enter your address for solar estimates and to locate trusted installers in your area. Installers will
                only receive your home address when you choose to connect. Learn how we protect your data in our{' '}
              </span>
              <Link href={privacyPolicyUrl}>Privacy Policy</Link>
              <span>.</span>
            </DS.Text>
          </DS.Flex>
        </DS.GridItem>
        <DS.GridItem alignItems="center" gap={4} justifyContent="center" size={{ _: 'full', md: 'third' }}>
          <DS.Flex flex={1}>
            <NumberedStep>2</NumberedStep>
            <H3>Verify your home details</H3>
            <DS.Text as="p" text="body14">
              To begin your journey into solar shopping, please provide detailed information about your home. This
              includes your location and your current monthly utility bills. This information will help us tailor the
              best solar solutions for your needs.
            </DS.Text>
          </DS.Flex>
        </DS.GridItem>
        <DS.GridItem alignItems="center" gap={4} justifyContent="center" size={{ _: 'full', md: 'third' }}>
          <DS.Flex flex={1}>
            <NumberedStep>3</NumberedStep>
            <H3>Get installer estimates nearby</H3>
            <DS.Text as="p" text="body14">
              Compare solar estimates from top-rated installers in your area to find the best deal for your home. Shop
              based on reputation, reviews, and financing options that fit your budget.
            </DS.Text>
          </DS.Flex>
        </DS.GridItem>
      </DS.Grid>
    </DS.Flex>
  </Section>
);
